import React, { useEffect, useState } from "react";
import AdminProfile from "./AdminProfile";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  Image,
  NumberInput,
  PasswordInput,
  Select,
  SimpleGrid,
  Text,
  TextInput,
} from "@mantine/core";
import useStyles from "./../Signup/style";

import { useForm } from "@mantine/form";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  addFacility,
  addLoginFacility,
  getAllFacilityTypes,
  getAllLoginFacilities,
  googleLogin,
  registerBusiness,
  signUp,
} from "../../services";
import { useSelector } from "react-redux";
import { getCookie, states } from "../../utils";
import { IoIosArrowDown } from "react-icons/io";
import { useMediaQuery } from "@mantine/hooks";
import { pageInfoAnalytics, TrackPageExit } from "../../config/mixpanelConfig";
import { GoogleLogin } from "@react-oauth/google";
import { stateZipCodes } from "../../utils/zipCodes";
import { PhoneInput } from "react-international-phone";

const AdminProfilePage = () => {
  const { classes } = useStyles();
  const [nextBtnDisable, setNextBtnDisable] = useState(false);
  const [isSkip, setIsSkip] = useState(false);
  const isMobile = useMediaQuery("(max-width: 430px)");
  const [stepCount, setStepCount] = useState(1);
  const { loading } = useSelector((state) => state?.auth);
  const { profile } = useSelector((state) => state.profile);
  //   const { facilities } = useSelector((state) => state?.facility);
  const { allFacilityTypes, loadingAddFacility } = useSelector(
    (state) => state.facility
  );
  // const selectedStateAbbr = getAbbreviationFromName(form?.values?.state);

  const navigate = useNavigate();
  const location = useLocation();

  // const [country, setCountry] = useState("ca"); // fallback
  // console.log("🚀 ~ AdminProfilePage ~ country:", country)

  // // 🔹 Detect country automatically using browser's geolocation (IP-based)
  // useEffect(() => {
  //   const detectCountry = async () => {
  //     try {
  //       console.log("🚀 ~ detectCountry ~ Fetching country code")
  //     const res = await fetch("https://get.geojs.io/v1/ip/geo.json");
  //       console.log("🚀 ~ detectCountry ~ res:", res)
  //       const data = await res.json();
  //       console.log("🚀 ~ detectCountry ~ data:", data)
  //       if (data?.country_code) {
  //         setCountry(data.country_code.toLowerCase());
  //       }
  //     } catch (err) {
  //       console.error("Country detection failed:", err);
  //     }
  //   };
  //   detectCountry();
  // }, []);

  useEffect(() => {
    pageInfoAnalytics("Sign Up Page Viewed", "Sign Up Page");
    TrackPageExit("Sign Up");
  }, []);

  const profileForm = useForm({
    initialValues: {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      password: "",
      repassword: "",
    },
    validate: {
      firstName: (value) => {
        if (!value) {
          return "First Name Required";
        }
        const nameRegex = /[a-zA-Z].*/;

        return nameRegex.test(value)
          ? null
          : "Admin must contain at least one alphabet and may have numbers";
      },
      lastName: (value) => {
        if (!value) {
          return "Last Name Required";
        }
        const nameRegex = /[a-zA-Z].*/;

        return nameRegex.test(value)
          ? null
          : "Admin must contain at least one alphabet and may have numbers";
      },
      phone: (value) => {
        if (!value) {
          return "Required";
        }
      },
      email: (value) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value)
          ? null
          : "Please enter a valid Admin email address";
      },
      password: (value) => {
        if (!value) {
          return "Required";
        }
        // Regular expression to check if the password contains at least one letter and one number
        const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).+$/;

        // Check if the password meets the length requirement
        const isLengthValid = value.length >= 8;

        return passwordRegex.test(value) && isLengthValid
          ? null
          : "Password must contain at least one letter, one number, and be at least 8 characters long";
      },
      repassword: (value, values) =>
        value !== values.password ? "Passwords did not match" : null,
    },
  });

  const businessForm = useForm({
    initialValues: {
      companyName: "",
      businessEmail: "",
      contactPhone: "",
    },
    validate: {
      companyName: (value) => {
        if (!value) {
          return "Required";
        }
        // Regular expression to check if the value contains at least one alphabet and may have numbers
        const nameRegex = /[a-zA-Z].*/;

        return nameRegex.test(value)
          ? null
          : "Business must contain at least one alphabet and may have numbers";
      },
      contactPhone: (value) => {
        if (!value) {
          return "Required";
        }
      },
      businessEmail: (value) => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value)
          ? null
          : "Please enter a valid Business email address";
      },
    },
  });

  const agencyForm = useForm({
    initialValues: {
      name: "",
      type: "",
      address: "",
      location: "",
      zipcode: "",
      state: "",
    },
    validate: {
      name: (value) => {
        if (!value && isSkip === false) {
          return "Required";
        }
        // Regular expression to check if the value contains at least one alphabet and may have numbers
        const nameRegex = /[a-zA-Z].*/;

        return nameRegex.test(value)
          ? null
          : "Admin must contain at least one alphabet and may have numbers";
      },
      type: (value) => {
        if (!value) {
          return "Required";
        }
      },
      address: (value) => {
        if (!value) {
          return "Required";
        }
        const addressRegex = /[a-zA-Z].*/;
        return addressRegex.test(value)
          ? null
          : "Facility must contain address";
      },

      // zipcode: (value) => {
      //   if (!value) {
      //     return "Required";
      //   }
      //   const codeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
      //   return codeRegex.test(value) ? null : "Valid zipcode code required";
      // },
      // state: (value) => {
      //   if (!value) {
      //     return "Required";
      //   }
      // },
    },
  });

  const handleProfileSubmit = async () => {
    const validationResults = await profileForm.validate();
    if (profileForm.validate().hasErrors) {
      const firstName = validationResults?.errors?.firstName;
      const lastName = validationResults?.errors?.lastName;
      const phone = validationResults?.errors?.phone;
      const email = validationResults?.errors?.email;
      const password = validationResults?.errors?.password;
      const repassword = validationResults?.errors?.repassword;

      if (firstName || lastName || phone || email || password || repassword) {
        return;
      }
    } else {
      const adminPayload = {
        name: `${profileForm?.values?.firstName} ${profileForm?.values?.lastName}`.trim(),
        firstName: profileForm?.values?.firstName,
        lastName: profileForm?.values?.lastName,
        phone: profileForm?.values?.phone,
        email: profileForm?.values?.email,
        password: profileForm?.values?.password,
        repassword: profileForm?.values?.repassword,
        rememberme: false,
        permissions: {
            aiAccess: false,
            staff: true,
            task: true,
            note: true,
            medication: true,
            report: true,
            facility: true,
            invoice: false,
            billing: false,
        }
      };
      // sign up api calll here
      try {
        const response = await signUp(adminPayload);

        if (response?.status === 200 || response?.response?.status === 201) {
          setNextBtnDisable(true);
          profileForm.reset();
        } else if (response?.response?.status === 500) {
          console.error("Server error: Unable to process the request.");
        }
      } catch (error) {
        console.log("🚀 ~ handleProfileSubmit ~ error:", error);
      }
    }
  };

  const handleBusinessSubmit = async () => {
    const validationResults = await businessForm.validate();
    if (businessForm.validate().hasErrors) {
      const companyName = validationResults?.errors?.companyName;
      const contactPhone = validationResults?.errors?.contactPhone;
      const businessEmail = validationResults?.errors?.businessEmail;

      if (companyName || contactPhone || businessEmail) {
        return;
      }
    } else {
      const businessPayload = {
        companyName: businessForm?.values?.companyName,
        businessEmail: businessForm?.values?.businessEmail,
        contactPhone: businessForm?.values?.contactPhone,
        agreeTerms: true,
      };

      const response = await registerBusiness(businessPayload, navigate);
      if (response?.status === 200) {
        setStepCount(3);
      }
    }
  };

  const handleFaciityType = async () => {
    const validationResults = await agencyForm.validate();
    if (agencyForm.validate().hasErrors && isSkip === false) {
      const name = validationResults?.errors?.name;
      const type = validationResults?.errors?.type;
      const address = validationResults?.errors?.address;
      const location = validationResults?.errors?.location;
      const zipcode = validationResults?.errors?.zipcode;
      const state = validationResults?.errors?.state;
      if (name || type || address || location || zipcode || state) {
        return;
      }
    } else {
      try {
        if (isSkip === false) {
          const facilityPayload = {
            name: agencyForm?.values?.name,
            type: agencyForm?.values?.type,
            address: agencyForm?.values?.address,
            location: agencyForm?.values?.location,
            zipcode: agencyForm?.values?.zipcode,
            state: agencyForm?.values?.state,
          };
          await addLoginFacility(facilityPayload, navigate);
        }
        navigate("/selectprice");
      } catch (error) {
        console.error("Error during signUp:", error);
      }
    }
  };

  useEffect(() => {
    if (location?.state?.token) {
      setStepCount(2);
    }
  }, [location?.state]);

  const renderStep1 = () => (
    <Step1
      classes={classes}
      loading={loading}
      form={profileForm}
      navigate={navigate}
      isMobile={isMobile}
      nextBtnDisable={nextBtnDisable}
      handleSubmit={handleProfileSubmit}
      // country={country}
      // setStepCount={handleChangeStep}
    />
  );

  const renderStep2 = () => (
    <Step2
      classes={classes}
      form={businessForm}
      navigate={navigate}
      handleSubmit={handleBusinessSubmit}
      loading={loading}
    />
  );

  const renderStep3 = () => (
    <Step3
      classes={classes}
      form={agencyForm}
      handleSubmit={handleFaciityType}
      loading={loading}
      facilityTypes={allFacilityTypes}
      isSkip={isSkip}
      setIsSkip={setIsSkip}
      loadingAddFacility={loadingAddFacility}
      // handleIsSkip={handleIsSkip}
    />
  );

  if (getCookie("token")) {
    if (profile?.user?.type && profile?.user?.type !== "staff")
      if (profile?.business) return <Navigate to="/selectprice" />;
  }

  // if (getCookie("token")) return <Navigate to="/" />;

  return (
    <>
      <AdminProfile
        step={stepCount}
        renderStep1={renderStep1}
        renderStep2={renderStep2}
        renderStep3={renderStep3}
      />
    </>
  );
};

export default AdminProfilePage;

const Step1 = ({
  classes,
  form,
  navigate,
  handleSubmit,
  loading,
  nextBtnDisable,
  isMobile,
  country,
}) => {
  console.log("🚀 ~ Step1 ~ country:", country);
  return (
    <Box>
      {isMobile && (
        <Image
          fit="fill"
          className={classes.logo}
          src="/assets/images/logo2.png"
        />
      )}
      <Text className={classes.stepTitle}>
        Step 01/<span className={classes.stepSpan}>03</span>
      </Text>
      <Text className={classes.title}>Create Admin Profile</Text>
      <Text fz={20} ff={"Inter"} color="#262626">
        Let’s get you all set up so you can access your personal account.{" "}
      </Text>
      <Box>
        <SimpleGrid cols={isMobile ? 1 : 2}>
          <TextInput
            mt={"lg"}
            id="signup-name"
            label="First Name"
            variant="default"
            placeholder="EG.abc"
            {...form.getInputProps("firstName")}
            size={"lg"}
          />
          <TextInput
            mt={"lg"}
            id="signup-name"
            label="Last Name"
            variant="default"
            placeholder="EG.abc"
            {...form.getInputProps("lastName")}
            size={"lg"}
          />
        </SimpleGrid>

        {/* <NumberInput
          mt={"lg"}
          size={"lg"}
          type="number"
          hideControls
          placeholder="+12"
          maxLength={11}
          id="number-input-demo"
          label="Admin Phone Number"
          {...form.getInputProps("phone")}
        /> */}
        <div className={classes.phoneInputBox}>
          <p className={classes.phoneLabel}>Admin Phone Number</p>
          <PhoneInput
            defaultCountry={"us"}
            placeholder="Enter phone number"
            {...form.getInputProps("phone")}
            className={classes.phoneInputWrapper}
            disableFormatting={false} // keeps phone number formatting (e.g. (123) 456-7890)
            forceDialCode={true} // always show country dial code
            showDisabledDialCode={true}
            autoFocus
          />
        </div>

        <TextInput
          mt={"lg"}
          variant="default"
          id="signup-email"
          label="Admin Email"
          placeholder="EG.abc@gmail.com"
          {...form.getInputProps("email")}
          size={"lg"}
        />
        <PasswordInput
          mt={"lg"}
          label="Password"
          variant="default"
          id="signup-password"
          placeholder="Eg.A*****"
          {...form.getInputProps("password")}
          size={"lg"}
        />
        <PasswordInput
          mt={"lg"}
          id="signup-confirm-password"
          label="Re-enter Password"
          variant="default"
          placeholder="Eg.A*****"
          {...form.getInputProps("repassword")}
          size={"lg"}
        />
      </Box>
      <Text fz={20} mt={10} ff={"Inter"} color="#262626">
        This information will be securely saved as per the{" "}
        <strong>
          <Link to="/term-conditions" className={classes.links}>
            Terms of Service
          </Link>{" "}
        </strong>
        &{" "}
        <strong>
          <Link to="/privacy-policy" className={classes.links}>
            Privacy Policy
          </Link>
        </strong>
      </Text>
      <Box mt={10} className={classes.googleBtn}>
        <GoogleLogin
          width={"250px"}
          size="large"
          text=""
          logo_alignment="center"
          onSuccess={(credentialResponse) => {
            googleLogin(
              {
                client_id: credentialResponse?.clientId,
                jwtToken: credentialResponse?.credential,
              },
              navigate
            );
          }}
          onError={() => {
            console.log("Login Failed");
          }}
        />
      </Box>
      {/* <SimpleGrid cols={2}> */}
      <Grid>
        <Grid.Col xs={12} sm={12} md={6}>
          <Button
            id="signup-button"
            type="submit"
            color="gray"
            className={classes.hepl_btn}
            onClick={() =>
              window.open("/contact-us", "_blank", "noopener,noreferrer")
            }
            // onClick={() => {
            //   navigate("/contact-us");
            // }}
          >
            Help?
          </Button>
        </Grid.Col>
        <Grid.Col xs={12} sm={12} md={6}>
          <Button
            id="signup-button"
            type="submit"
            color="yellow"
            loading={loading}
            disabled={loading || nextBtnDisable}
            className={classes.nextAndCreateAccountBtn}
            // onClick={() => setStepCount(2)}
            onClick={handleSubmit}
          >
            Next Step
          </Button>
        </Grid.Col>
      </Grid>

      {/* </SimpleGrid> */}
    </Box>
  );
};

const Step2 = ({ classes, form, navigate, handleSubmit, loading }) => {
  return (
    <Box className={classes.bgHeight}>
      <Text className={classes.stepTitle}>
        Step 02/<span className={classes.stepSpan}>03</span>
      </Text>
      <Text className={classes.title}>Create Business Profile</Text>
      <Text fz={20} ff={"Inter"} color="#262626">
        Let’s get your business profile setup
      </Text>
      <Box>
        <TextInput
          mt={"lg"}
          id="signup-name"
          label="Business Name"
          variant="default"
          placeholder="Business Name"
          {...form.getInputProps("companyName")}
          size={"lg"}
        />
        <TextInput
          mt={"lg"}
          id="signup-email"
          label="Business Email"
          variant="default"
          placeholder="Business Email"
          {...form.getInputProps("businessEmail")}
          size={"lg"}
        />
        {/* <NumberInput
          mt={"lg"}
          size={"lg"}
          hideControls
          placeholder="Business Phone Number"
          id="number-input-demo"
          label="Business Phone Number"
          {...form.getInputProps("contactPhone")}
        /> */}
        <div className={classes.phoneInputBox}>
          <p className={classes.phoneLabel}>Business Phone Number</p>
          <PhoneInput
            defaultCountry={"us"}
            placeholder="Enter phone number"
            {...form.getInputProps("contactPhone")}
            className={classes.phoneInputWrapper}
            disableFormatting={false} // keeps phone number formatting (e.g. (123) 456-7890)
            forceDialCode={true} // always show country dial code
            showDisabledDialCode={true}
            autoFocus
          />
        </div>
      </Box>
      <Text fz={20} mt={10} ff={"Inter"} color="#262626">
        This information will be securely saved as per the{" "}
        <strong>
          <Link to="/term-conditions" className={classes.links}>
            Terms of Service
          </Link>{" "}
        </strong>
        &{" "}
        <strong>
          <Link to="/privacy-policy" className={classes.links}>
            Privacy Policy
          </Link>
        </strong>
      </Text>
      <SimpleGrid cols={2}>
        <Button
          id="signup-button"
          // loading={loading}
          type="submit"
          color="yellow"
          className={classes.hepl_btn}
          onClick={() =>
            window.open("/contact-us", "_blank", "noopener,noreferrer")
          }
          // onClick={() => {
          //   navigate("/contact-us");
          // }}
        >
          Help?
        </Button>

        <Button
          id="signup-button"
          loading={loading}
          type="submit"
          color="yellow"
          className={classes.nextAndCreateAccountBtn}
          onClick={handleSubmit}
        >
          Next Step
        </Button>
      </SimpleGrid>
    </Box>
  );
};

const Step3 = ({
  classes,
  form,
  handleSubmit,
  loading,
  facilityTypes,
  isSkip,
  setIsSkip,
  loadingAddFacility,
  // handleIsSkip,
}) => {
  // const [isSkip, setIsSkip] = useState(false);
  // console.log("isSkip =>", isSkip);
  // console.log("allFacilityTypes =>", facilityTypes);

  useEffect(() => {
    getAllFacilityTypes();
  }, []);

  return (
    <Box className={classes.bgHeight}>
      <Text className={classes.stepTitle}>
        Step 03/<span className={classes.stepSpan}>03</span>
      </Text>
      {/* <Text className={classes.title}>Agency Setup</Text> */}
      <Text m={0} className={classes.title}>
        Facility Setup
      </Text>
      {/* <Text fz={20} ff={"Inter"} color="#262626">
        Please tell us about your agency
      </Text> */}
      <Box>
        {/* ----- Facility Name ----- */}
        <TextInput
          disabled={isSkip ? true : false}
          id="signup-name"
          label="Facility Name"
          variant="default"
          placeholder="Facility Name"
          {...form.getInputProps("name")}
          size={"sm"}
        />
        {/* ----- Facility Type -----  */}
        <Select
          disabled={isSkip ? true : false}
          label="Facility Type"
          id="select-demo"
          mt={"sm"}
          size={"sm"}
          rightSection={<IoIosArrowDown size={16} />}
          placeholder="Facility Type"
          {...form.getInputProps("type")}
          data={
            facilityTypes?.ftypes?.map((val) => ({
              value: val?.id,
              label: val?.name,
            })) || []
          }
        />
        {/* ----- Address ----- */}
        <TextInput
          disabled={isSkip ? true : false}
          mt={"sm"}
          label="Address"
          variant="default"
          placeholder="Facility Address"
          {...form?.getInputProps("address")}
          size="sm"
        />
        {/* ----- Address Two ----- */}
        <TextInput
          disabled={isSkip ? true : false}
          mt={"sm"}
          label="Address 2"
          variant="default"
          placeholder="Apt/Suit #"
          {...form.getInputProps("location")}
          size="sm"
        />
        <Grid>
          {/* ----- Zip Code ----- */}
          <Grid.Col xs={12} sm={12} md={6}>
            <TextInput
              disabled={isSkip ? true : false}
              mt={"sm"}
              label="Zip Code"
              variant="default"
              placeholder="Ex: 23464"
              {...form.getInputProps("zipcode")}
              size="sm"
            />
          </Grid.Col>
          {/* ----- State ----- */}
          <Grid.Col xs={12} sm={12} md={6}>
            <Select
              disabled={isSkip ? true : false}
              label="State"
              mt={{ xs: 0, sm: 0, md: "sm" }}
              size={"sm"}
              rightSection={<IoIosArrowDown size={16} />}
              placeholder="Select State"
              {...form.getInputProps("state")}
              // ----- Importing states from utils/index.js ----- \\
              // data={states}
              data={Array.from(
                new Set(stateZipCodes?.map((obj) => obj.ste_name))
              )
                .sort()
                .map((ste_name) => ({
                  value: ste_name,
                  label: ste_name,
                }))}
            />
          </Grid.Col>
        </Grid>
      </Box>
      <Checkbox
        onChange={() => {
          setIsSkip((prev) => !prev);
          form.reset();
        }}
        // value={isSkip}
        mt={"md"}
        color="yellow"
        defaultChecked={false}
        label="Skip for now"
      />
      <Text
        fz={{ xs: 10, sm: 15, md: 20 }}
        mt={10}
        ff={"Inter"}
        color="#262626"
      >
        This information will be securely saved as per the{" "}
        <strong>
          <Link to="/term-conditions" className={classes.links}>
            Terms of Service
          </Link>{" "}
        </strong>
        &{" "}
        <strong>
          <Link to="/privacy-policy" className={classes.links}>
            Privacy Policy
          </Link>
        </strong>
      </Text>
      <Button
        id="signup-button"
        // loading={loading}
        loading={loadingAddFacility}
        type="submit"
        color="yellow"
        className={`${classes.createAccountBtnCSS}`}
        onClick={handleSubmit}
      >
        Create Accout
      </Button>
    </Box>
  );
};
